<template>
    <div >
        <el-carousel :interval="5000" indicator-position="none" :height="screenheight">
            <el-carousel-item v-for="(item, index) in data_list.sylb_tp" :key="index">
                <img :src="item.format_img" style="width: 100%; height: 100%;" alt="" @click="openweb(item.image_url)">
            </el-carousel-item>
        </el-carousel>

        <div style="width: 1200px; height: 840px; margin: 0 auto;" class="flx fdc jcc" id="dom1">
            <transition name="el-zoom-in-center">
                <div v-show="dom1_show">
                    <div class="flx aic jcc">
                        <!-- <div style="width: 3px; height: 33px; background-color: #C8161D; margin-top: 4px;"></div> -->
                        <b class="cl3" style="font-size: 34px;">关于我们</b>
                        <!-- <div style="height: 38px; margin-left: 18px;" class="flx aif"><span style="font-size: 14px; color: rgb(153, 153, 153);">About us</span></div> -->
                    </div>
                    <div class="flx jcc mt5">
                        <p style="width: 1100px; font-size: 15px; line-height: 30px; display: inline-block;" class="tc cl6">{{data_list.gywm_js}}</p>
                    </div>
                </div>
            </transition>
            <transition name="el-zoom-in-center">
                <div class="hdfghfj flx" ref="init" @mouseover="yuio" @mouseleave="sdfgsd" style="margin-top: 40px; width: 1200px;" v-show="dom1_show">
                    <div ref="m1" class="flx">
                        <div class="fghjgfhjk" v-for="(item, index) in data_list.gywm_tp" :key="index" >
                            <img style="width: 280px; height: 400px;" :src="item.format_img">
                        </div>
                    </div>
                    <div ref="m2" class="flx">
                        <div class="fghjgfhjk" v-for="(item2, index2) in data_list.gywm_tp" :key="index2">
                            <img style="width: 280px; height: 400px ;" :src="item2.format_img">
                        </div>
                    </div>
                </div>
            </transition>
            <transition name="el-zoom-in-center">
                <router-link :to="{ path: '/index2', query: { name: '关于我们' }}" style="width: 168px; height: 48px; border: 1px solid #C8161D; color: #C8161D; font-size: 14px; margin: 50px auto 0 auto; text-decoration: none;" class="flx aic jcc shouxing router-linkz" v-show="dom1_show">了解更多</router-link>
            </transition>
        </div>

        <div class="flx fdc jcc" id="dom2" style="height: 1000px;">
            <transition name="el-zoom-in-center">
                <div style="width: 1200px; margin: 0 auto;" v-show="dom2_show">
                    <div class="flx fdc aic">
                        <b style="font-size: 34px;" class="cl3">专家委员会</b>
                        <div class="mt5 flx jcc">
                            <p style="font-size: 15px; line-height: 30px; display: inline-block; width: 1100px;" class="tc cl6">{{data_list.dkyj_js}}</p>
                        </div>
                    </div>
                    <div style="display: grid;grid-template-columns: repeat(5, 1fr); grid-column-gap: 50px; grid-row-gap: 50px;" class="mt30">
                        <router-link :to="{ path: '/bigshotinfo', query: { id: item.id }}" style="width: 200px; height: 300px;" class="pr" v-for="(item, index) in data_list.dkyj_all" :key="index">
                            <img style="width: 200px; height: 300px;" :src="item.format_img" alt="">
                            <div class="pa flx fdc jcc" style="width: 170px; height: 110px; background-color: rgba(125,125,125,0.5); bottom: 50px; padding: 0 15px;">
                                <div class="clf tc fs14">{{item.name}}</div>
                                <span class="clf dv3 mt5 dddddff" style="font-size: 12px; line-height: 20px; letter-spacing: 1px" v-html="item.image_content"></span>
                            </div>
                        </router-link>
                    </div>
                    <router-link :to="{ path: '/bigshotlist', query: { name: '专家委员会' }}" class="flx aic jcc shouxing router-linkz" style="width: 168px; height: 48px; border: 1px solid #C8161D; color: #C8161D; font-size: 14px; margin: 60px auto 0 auto;">了解更多</router-link>
                </div>
            </transition>
        </div>

        <el-carousel :interval="5000" indicator-position="none" :height="screenheight" v-if="data_list.zjjs_tp && data_list.zjjs_tp.length > 0">
            <el-carousel-item v-for="(item, index) in data_list.zjjs_tp" :key="index">
                <img :src="item.format_img" style="width: 100%; height: 100%;" alt="" @click="openweb(item.image_url)">
            </el-carousel-item>
        </el-carousel>

        <div class="dfggd flx aic" id="dom4">
            <transition name="el-zoom-in-center">
                <div style="width: 1200px; margin: 100px auto;" v-show="dom4_show">
                    <div class="flx fdc aic">
                        <b style="font-size: 34px;">合作领域</b>
                        <!-- <span style="font-size: 14px; color: rgb(153, 153, 153); margin-top: 15px;">Cooperative partner</span> -->
                    </div>
                    <div style="display: grid;grid-template-columns: repeat(5, 1fr); grid-column-gap: 75px; grid-row-gap: 75px;" class="mt50">
                        <img class="shouxing" @click="toinfo(item.id)" style="width: 180px; height: 180px;" v-for="(item, index) in data_list.hzhb_tp" :key="index" :src="item.format_img" alt="">
                    </div>

                    <router-link :to="{ path: '/index3', query: { name: '关于我们' }}" style="width: 168px; height: 48px; border: 1px solid #C8161D; color: #C8161D; font-size: 14px; margin: 60px auto 0 auto;" class="flx aic jcc shouxing router-linkz">了解更多</router-link>
                </div>
            </transition>
        </div>

        <div style="width: 1200px; height: 900px; margin: 0 auto 20px auto;" class="flx fdc aic jcc" id="dom3">
            <transition name="el-zoom-in-center">
                <div class="flx fdc aic" v-show="dom3_show">
                    <b style="font-size: 32px;">最新资讯</b>
                    <!-- <span style="font-size: 14px; color: rgb(153, 153, 153); margin-top: 15px;">Latest information</span> -->
                </div>
            </transition>
            <transition name="el-zoom-in-center">
                <div class="" style="margin-top: 50px; width: 1120px; padding: 0 40px;" v-show="dom3_show">
                    <div class="flx jcsb" style="width: 1120px;">
                        <img v-for="(item, index) in data_list.xwzx_tp" :key="index" style="width: 540px; height: 320px;" :src="item.format_img" alt="" @click="openweb(item.image_url)">
                    </div>

                    <div class="flx jcsb fww mt30">
                        <router-link :to="{ path: '/articledetails', query: { id: item.article_id }}" class="flx jcsb shouxing router-linkz" style="width: 500px; padding: 15px 15px 0 15px; border-bottom: 1px solid #eee;" v-for="(item, index) in data_list.xwzx_xw" :key="index">
                            <div style="color: #626971; width: 80px;" class="flx fdc">
                                <span style="font-size: 26px;">{{item.article_date}}</span>
                                <span style="font-size: 14px;" class="mt5">{{item.article_year}}</span>
                            </div>
                            <div style="width: 400px;">
                                <span style="font-size: 16px;" class="dffaaa">{{item.article_title}}</span>
                                <p class="dv2 fs14 flx" style="color: #878787; line-height: 26px;" v-html="item.article_content"></p>
                            </div>
                        </router-link>
                    </div>
                    <router-link :to="{ path: '/index5', query: { name: '最新资讯' }}" style="width: 168px; height: 48px; border: 1px solid #C8161D; color: #C8161D; font-size: 14px; margin: 60px auto 0 auto;" class="flx aic jcc shouxing router-linkz">了解更多</router-link>
                </div>
            </transition>
        </div>

    </div>
</template>

<script>
export default {
    name: 'Index',
    metaInfo: {
        title: '中小型优质农产品生产商服务平台 - 交农一品 | 上海上通优选农业科技发展有限公司',
        meta: [
            { keywords: '交农一品,上通优选,农产品平台,中小型农产品生产商,上海上通优选农业科技发展有限公司,品牌授权,农产品品牌服务' },
            { description: '交农一品,隶属于上海上通优选农业科技发展有限公司,秉持三农情怀,为解决我国中小型农产品生产商在品牌运作、市场营销、持续发展方面的困境,特提供品牌赋能、技术支持、市场营销三大助力,为中国一流品质的农产品保驾护航,系为中小型优质农产品生产商提供品牌赋能、销售渠道服务的专业平台' }
        ]
    },
    data () {
        return {
            screenheight: '500px',
            setInter: '',
            data_list: '',
            dom1_show: false,
            dom2_show: false,
            dom3_show: false,
            dom4_show: false,
            screenWidth: null
        }
    },
    methods:{
        scrollHandle() {
            const offset1 = dom1.getBoundingClientRect();
            const offsetTop1 = offset1.top;
            const offsetBottom1 = offset1.bottom;
            if (offsetTop1 <= window.innerHeight - 300 && offsetBottom1 - 300 >= 0) {
                this.dom1_show = true
            }
            const offset2 = dom2.getBoundingClientRect();
            const offsetTop2 = offset2.top;
            const offsetBottom2 = offset2.bottom;
            if (offsetTop2 <= window.innerHeight - 300 && offsetBottom2 - 300 >= 0) {
                this.dom2_show = true
            }
            const offset3 = dom3.getBoundingClientRect();
            const offsetTop3 = offset3.top;
            const offsetBottom3 = offset3.bottom;
            if (offsetTop3 <= window.innerHeight - 300 && offsetBottom3 - 300 >= 0) {
                this.dom3_show = true
            }
            const offset4 = dom4.getBoundingClientRect();
            const offsetTop4 = offset4.top;
            const offsetBottom4 = offset4.bottom;
            if (offsetTop4 <= window.innerHeight - 300 && offsetBottom4 - 300 >= 0) {
                this.dom4_show = true
            }
        },

        Marquee() {
            this.$nextTick(() => {
                if(this.$refs.init.scrollLeft >= this.$refs.m1.offsetWidth) {
                    this.$refs.init.scrollLeft = 0
                } else {
                    this.$refs.init.scrollLeft ++
                }
            })
        },

        yuio() {
            clearInterval(this.setInter)
        },

        sdfgsd() {
            var that = this;
            this.setInter = setInterval(function() {
                that.Marquee();
            }, 20);
        },

        toinfo(id) {
            this.$router.push({
                path: '/allstore',
                query: {
                    id: id
                }
            })
        },

        openweb(e) {
            if(e) {
                window.open(e)
            }
        },

        getData() {
            this.$post('index.php?s=/api/index/index', {
                wxapp_id: 10001
            })
            .then((res) => {
                if(res.code == 1) {
                    var a_data = res.data.list;
                    for (let i = 0; i < a_data.xwzx_xw.length; i++) {
                        a_data.xwzx_xw[i].article_content = this.showHtml(a_data.xwzx_xw[i].article_content);
                        a_data.xwzx_xw[i].article_content = a_data.xwzx_xw[i].article_content.replace(/<\/?br[^>]*>/gi,'')
                    }
                    for (let i = 0; i < a_data.dkyj_all.length; i++) {
                        if(a_data.dkyj_all[i].image_content) {
                            a_data.dkyj_all[i].image_content = this.showHtml(a_data.dkyj_all[i].image_content);
                            a_data.dkyj_all[i].image_content = a_data.dkyj_all[i].image_content.replace(/<\/?br[^>]*>/gi,'')
                        }
                    }
                    this.data_list = a_data;
                }
            }) 
        },
        showHtml(str){
            return str
            .replace(str ? /&(?!#?\w+;)/g : /&/g, '&amp;')
            .replace(/&lt;/g,"<")
            .replace(/&gt;/g,">")
            .replace(/&quot;/g,"\"")
            .replace(/&#39;/g, "\'")
            .replace(/<\/?p[^>]*>/gi,'')
            .replace(/<\/?hr[^>]*>/gi,'')
            .replace(/<\/?img[^>]*>/gi,'')
            .replace(/&amp;nbsp;/g,'\u3000')
        },
    },
    watch: {
        screenWidth: {
            handler: function (val, oldVal) {
                if (val*500/1920 < 321.5) {
                    this.screenheight = '321.5px';
                } else {
                    this.screenheight = val*500/1920 + 'px';
                }
            },
        },
    },
    created() {
        this.getData();
    },
    mounted() {
        var that = this;
        this.setInter = setInterval(function() {
            that.Marquee();
        }, 20);
        this.scrollHandle();
        window.addEventListener("scroll", this.scrollHandle);
        this.screenWidth = document.body.clientWidth;
        window.onresize = () => {
            return (() => {
                this.screenWidth = document.body.clientWidth;
            })()
        }
	},
    destroyed() {
        clearInterval(this.setInter)
        window.removeEventListener("scroll", this.scrollHandle)
    }
}
</script>

<style scoped>
    .fghjgfhjk{
        margin: 0 10px;
    }
    .hdfghfj{
        overflow-x: hidden;
    }
    .dfggd{
        background: url(//21092388.s61i.faiusr.com/2/AD0IpLCHChACGAAgscPB7wUooOS1DzCADzjeAw.jpg.webp) repeat top ,transparent;
        background-size: cover;
        height: 790px;
    }
    .ttyyuu{
        background: url(//11775317.s61i.faiusr.com/2/AD0I1drOBRACGAAg4a6H2gUolNDy1AYwgA84gwQ.jpg.webp) no-repeat center;
        background-size: cover;
        height: 506px;
    }
    .chakan{
        border: 1px solid #C8161D;
        color: #C8161D;
        font-size: 16px;
        padding: 13px 0;
        width: 180px;
        text-align: center;
    }
    .dddddff >>> p {
        margin: 0;
    }
    .dffaaa{
        color: #333;
    }
    .dffaaa:hover{
        color: #C8161D;
    }
</style>


// WEBPACK FOOTER //
// src/components/index/index.vue